import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

type InsightItemProps = {
  label: string;
  value: number;
};

const InsightItem = ({ label, value }: InsightItemProps) => (
  <div>
    <div className="flex justify-between mb-1">
      <span className="text-sm text-muted-foreground">{label}</span>
      <span className="text-sm font-medium">{value}%</span>
    </div>
    <Progress value={value} className="h-2" />
  </div>
);

type InsightCardProps = {
  title: string;
  items: InsightItemProps[];
};

const InsightCard = ({ title, items }: InsightCardProps) => (
  <Card className="hover:shadow-lg transition-shadow">
    <CardHeader>
      <CardTitle className="text-lg">{title}</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      {items.map((item, index) => (
        <InsightItem key={index} {...item} />
      ))}
    </CardContent>
  </Card>
);

export const AppointmentInsights = () => {
  const insights = [
    {
      title: "Spécialités consultées",
      items: [
        { label: "Médecin généraliste", value: 0 },
        { label: "Dentiste", value: 0 },
        { label: "Ophtalmologue", value: 0 }
      ]
    },
    {
      title: "Lieux de consultation",
      items: [
        { label: "Cabinet médical", value: 0 },
        { label: "Hôpital", value: 0 },
        { label: "Clinique", value: 0 }
      ]
    }
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2">
      {insights.map((insight, index) => (
        <InsightCard key={index} {...insight} />
      ))}
    </div>
  );
};